import React from "react";
import LTLogo from "./LTLogo";
import { Instagram, Mail } from "lucide-react";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[var(--lt-peace)] border-t border-[var(--lt-line)] pt-20 pb-10"
    >
      <div className="container mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 lg:col-span-6">
            <h3
              className="font-display tracking-editorial text-[var(--lt-charcoal)] leading-[0.95]"
              style={{ fontSize: "clamp(2.4rem, 7vw, 6.4rem)", fontWeight: 600 }}
            >
              Little<em className="italic text-[var(--lt-bark)]"> things.</em>
              <br />
              Big <em className="italic text-[var(--lt-bark)]">influence.</em>
            </h3>
          </div>
          <div className="col-span-6 lg:col-span-3 lg:col-start-8">
            <p className="eyebrow mb-4">Studio</p>
            <ul className="space-y-2 text-sm text-[var(--lt-charcoal)]/80">
              <li>
                <a href="/#services" className="lt-link">Services</a>
              </li>
              <li>
                <a href="/#work" className="lt-link">Work</a>
              </li>
              <li>
                <a href="/showcase" className="lt-link">Showcase</a>
              </li>
              <li>
                <a href="/#process" className="lt-link">Process</a>
              </li>
              <li>
                <a href="/#about" className="lt-link">About</a>
              </li>
            </ul>
          </div>
          <div className="col-span-6 lg:col-span-3">
            <p className="eyebrow mb-4">Contact</p>
            <ul className="space-y-2 text-sm text-[var(--lt-charcoal)]/80">
              <li>
                <a
                  href="mailto:Mehak@littlethings.ltd"
                  className="lt-link inline-flex items-center gap-2"
                  data-testid="footer-email"
                >
                  <Mail size={14} /> Mehak@littlethings.ltd
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/littlethings.ltd_"
                  target="_blank"
                  rel="noreferrer"
                  className="lt-link inline-flex items-center gap-2"
                  data-testid="footer-instagram"
                >
                  <Instagram size={14} /> Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="hairline mb-6" />
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <LTLogo dataTestid="footer-logo" variant="stacked" height={48} />
          <p className="text-xs text-[var(--lt-bark)]/70 tracking-[0.1em]">
            © {year} Little Things Studio. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
